module.exports = "<contractor-invoice-page></contractor-invoice-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appCustomers/contractorInvoice.html
// module id = 2039
// module chunks = 0